export default __webpack_public_path__ + "static/media/brouchure.400ce424.png";